import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsColConfigService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }


  save(reportsColoumnsConfigurations: any) {
    return this.http.post(this.configurations.apiAddress + "/api/ReportsColoumnsConfiguration/save", reportsColoumnsConfigurations);
  }

  getAllReportsName() {
    return this.http.get(this.configurations.apiAddress + '/api/ReportsColoumnsConfiguration/getAllReportsName');
  }

  delete(reportName: string) {
    return this.http.delete(this.configurations.apiAddress + '/api/ReportsColoumnsConfiguration/delete/' + reportName);
  }

  getByReportName(reportName: string) {
    return this.http.get(this.configurations.apiAddress + '/api/ReportsColoumnsConfiguration/getByReportName/' + reportName);
  }
   
}
